import { useState } from "react";
import { t } from "ttag";

import Modal from "metabase/components/Modal";
import ModalContent from "metabase/components/ModalContent";
import Button from "metabase/core/components/Button";
import { MBMessageTypes, useCubeMessenger } from "metabase/cube";
import * as Urls from "metabase/lib/urls";
import type Question from "metabase-lib/Question";
import type { Card, Dashboard } from "metabase-types/api";

import LoadingSpinner from "../../../components/LoadingSpinner";

import {
  ModalMessage,
  StyledButtonContainer,
  StyledDeleteButton,
} from "./styles";

type DeleteQuestionButtonProps = {
  archive: (card: Card) => void;
  dashboard: Dashboard;
  iconSize: number;
  question: Question;
  router: any;
};

export const DeleteQuestionButton = ({
  archive,
  dashboard,
  iconSize,
  question,
  router,
}: DeleteQuestionButtonProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { sendMessage } = useCubeMessenger();

  const onClose = () => {
    setIsOpen(false);
  };

  const onDelete = async () => {
    setIsSubmitting(true);

    const card = question.card();
    await archive(card);

    router.push(Urls.dashboard(dashboard));

    setIsSubmitting(false);
    setIsOpen(false);
    sendMessage({
      payload: {
        message: "Question deleted",
        data: {
          "Dashboard name": dashboard.name,
          "Question name": card.name,
        },
      },
      type: MBMessageTypes.analyticsTrackEvent,
    });
  };

  return (
    <>
      <StyledDeleteButton
        data-testid="delete-question-button"
        iconSize={iconSize}
        icon="trash"
        onlyIcon
        onClick={() => setIsOpen(true)}
      />
      <Modal isOpen={isOpen}>
        <ModalContent title={t`Delete Question`} onClose={onClose}>
          <ModalMessage>{t`Proceeding will permanently delete this question, this action cannot be undone. Are you sure you want to do this?`}</ModalMessage>
          <StyledButtonContainer>
            <Button onClick={onClose}>{t`Cancel`}</Button>
            <Button
              danger
              onClick={onDelete}
              disabled={isSubmitting}
              data-testid="confirm-delete-button"
            >
              {t`Delete`}
            </Button>
            {isSubmitting && (
              <LoadingSpinner className="inline action-spin" size={22} />
            )}
          </StyledButtonContainer>
        </ModalContent>
      </Modal>
    </>
  );
};
